
const contents = "mutation UpdateUserPreferencesClients($isModernClientPreferred: Boolean!) {\n  updateUserPreferences(\n    input: {isModernClientPreferred: $isModernClientPreferred}\n  ) {\n    userPreferences {\n      webClientPreference\n    }\n  }\n}";
const sha256Hash = "a8300762f5d90a338be7cf3810e856cbef8aa20c63a397669b11d13472cb5650";
export default { contents: contents, sha256Hash: sha256Hash };
